/**
 * Moeda e formatação local para a landing WSJ Pedidos (sem API externa).
 * pt-BR → BRL (R$) · pt-PT → EUR (€) · restante → USD ($) com valores EN dedicados.
 */

const WSJ_PEDIDOS_AMOUNTS = {
  heroOrder: 47.9,
  heroProductFrom: 120,
  demoMenuFrom: 89
};

/** Preços por mercado (Starter = período de teste a €0/R$0; Pro/Premium = mensal pago). */
const WSJ_PEDIDOS_PLANS = {
  'pt-BR': { starter: 0, pro: 159.9, premium: 409.9 },
  'pt-PT': { starter: 0, pro: 39.9, premium: 69.9 },
  en: { starter: 0, pro: 39.9, premium: 69.9 }
};

const formatterCache = new Map();

function cacheKey(locale, currency) {
  return `${locale}\0${currency}`;
}

function getFormatter(locale, currency) {
  const key = cacheKey(locale, currency);
  if (!formatterCache.has(key)) {
    formatterCache.set(
      key,
      new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    );
  }
  return formatterCache.get(key);
}

function formatZeroPrice(planKey) {
  if (planKey === 'pt-BR') return 'R$ 0';
  if (planKey === 'pt-PT') return '0 €';
  return '0 US$';
}

function formatUsdPrice(amount) {
  const value = new Intl.NumberFormat('pt-PT', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
  return `${value} US$`;
}

/**
 * @param {string} language — código do LanguageContext (pt-BR, pt-PT, en, …)
 * @returns {{ locale: string, currency: string, planKey: 'pt-BR'|'pt-PT'|'en' }}
 */
export function getWsjPedidosMoneyProfile(language) {
  if (language === 'pt-PT') {
    return { locale: 'pt-PT', currency: 'EUR', planKey: 'pt-PT' };
  }
  if (language === 'pt-BR') {
    return { locale: 'pt-BR', currency: 'BRL', planKey: 'pt-BR' };
  }
  return { locale: 'en-US', currency: 'USD', planKey: 'en' };
}

export function formatWsjPedidosPrice(amount, language) {
  const { locale, currency, planKey } = getWsjPedidosMoneyProfile(language);
  const value = Number(amount);
  if (!Number.isFinite(value)) return '';

  if (value === 0) return formatZeroPrice(planKey);
  if (planKey === 'en') return formatUsdPrice(value);

  return getFormatter(locale, currency).format(value);
}

export function getWsjPedidosAmounts() {
  return WSJ_PEDIDOS_AMOUNTS;
}

export function getWsjPedidosPlanMonthlyPrices(language) {
  const { planKey } = getWsjPedidosMoneyProfile(language);
  return WSJ_PEDIDOS_PLANS[planKey];
}

/** Plano anual: cobrança de 10 meses pelo período de 12 (2 meses equivalentes em poupança). */
export const WSJ_PEDIDOS_ANNUAL_MONTHS_PAID = 10;

export function getWsjPedidosAnnualBundle(monthlyPrice) {
  const yearlyCharge = monthlyPrice * WSJ_PEDIDOS_ANNUAL_MONTHS_PAID;
  const effectiveMonthly = yearlyCharge / 12;
  const fullYearList = monthlyPrice * 12;
  const savedVsList = fullYearList - yearlyCharge;
  const savingsPercent = fullYearList > 0 ? Math.round((savedVsList / fullYearList) * 100) : 0;
  return { yearlyCharge, effectiveMonthly, savedVsList, savingsPercent };
}
